import { Component, OnInit, Optional, Inject } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DentalService } from 'src/app/_service/dental.service';
declare var $: any;

@Component({
  selector: 'app-scan-pro-assignment',
  templateUrl: './scan-pro-assignment.component.html',
  styleUrls: ['./scan-pro-assignment.component.css']
})
export class ScanProAssignmentComponent implements OnInit {
  scanProForm: FormGroup; submitted = false; loading: boolean = false; scanId: any = ''; scanProUser = [];
  constructor(public dialogRef: MatDialogRef<ScanProAssignmentComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private sharedapi: SharedService, private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute,private dentalapi: DentalService) {
      dialogRef.disableClose = true;
      this.scanId = data.scanId;
      this.scanProForm = this.formBuilder.group({
        'scan_pro': [null, Validators.required],
      });
    }

  ngOnInit(): void {
    this.getScanProUser();
    this.patchScanproData();
  }

  get f() { return this.scanProForm.controls; }

  CloseModal(): void {
    this.dialogRef.close();
  }

  async scanProAssignment()
  {
    this.submitted = true;
    this.loading = true;

    if (this.scanProForm.invalid) {
      this.loading = false;
      return;
    }
    this.scanProForm.value.scanId = parseInt(this.scanId);
    await this.dentalapi.updateScanbookDataForPro(this.scanProForm.value)
      .subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      this.sharedapi.presentToast(data.msg);
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async patchScanproData() {
    this.loading = true;
    this.dentalapi.getScanbookData(this.scanId).subscribe((response: any) => {
      if (response.status) {
        this.loading = false;
        this.scanProForm.patchValue({
          'scan_pro': response.data.scan_pro_userid ? response.data.scan_pro_userid : '' ,
        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getScanProUser()
  {
      await this.dentalapi.getscanprouser().subscribe((data:any) => {
          if(data.status)
          {
              this.scanProUser = data.data;
              
          }else{
              this.scanProUser = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

}
